import { defineComponent as o, createBlock as r, openBlock as t, unref as n, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconGear",
  __name: "IconGear",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(e) {
    const l = e;
    return (v, a) => (t(), r(n(m), p(l, { "view-box": "0 0 24 24" }), {
      default: c(() => [...a[0] || (a[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M10.75 3.75v1.167a1.274 1.274 0 0 1-.852 1.195 6.242 6.242 0 0 0-1.94 1.121 1.274 1.274 0 0 1-1.456.143L5.48 6.792 4.229 8.96l1.023.61a1.276 1.276 0 0 1 .597 1.32 6.515 6.515 0 0 0 .008 2.268 1.276 1.276 0 0 1-.637 1.355l-.986.536 1.246 2.16 1.015-.586a1.273 1.273 0 0 1 1.452.133 6.592 6.592 0 0 0 1.954 1.133 1.277 1.277 0 0 1 .849 1.195v1.167h2.5v-1.167a1.273 1.273 0 0 1 .854-1.195 6.116 6.116 0 0 0 1.945-1.118 1.275 1.275 0 0 1 1.464-.143l1.007.58 1.25-2.165-1.014-.585a1.272 1.272 0 0 1-.612-1.316 6.799 6.799 0 0 0 0-2.282 1.272 1.272 0 0 1 .612-1.316l1.014-.585-1.25-2.166-1.022.59a1.265 1.265 0 0 1-1.43-.119c-.614-.498-1.26-.894-1.97-1.151a1.277 1.277 0 0 1-.848-1.195V3.75h-2.5M9.25 3.5a1.25 1.25 0 0 1 1.25-1.25h3a1.25 1.25 0 0 1 1.25 1.25v1.254a8.278 8.278 0 0 1 2.14 1.247l1.096-.633a1.25 1.25 0 0 1 1.708.458l1.5 2.598a1.25 1.25 0 0 1-.458 1.708l-1.089.628a8.29 8.29 0 0 1 0 2.48l1.09.628a1.25 1.25 0 0 1 .457 1.708l-1.5 2.598a1.25 1.25 0 0 1-1.708.458l-1.08-.624a7.611 7.611 0 0 1-2.156 1.24V20.5a1.25 1.25 0 0 1-1.25 1.25h-3a1.25 1.25 0 0 1-1.25-1.25v-1.254a8.11 8.11 0 0 1-2.147-1.243l-1.09.629a1.25 1.25 0 0 1-1.707-.458l-1.5-2.598a1.25 1.25 0 0 1 .458-1.708L3.28 13.86l1.075-.584a8.035 8.035 0 0 1-.009-2.5L3.26 10.13a1.25 1.25 0 0 1-.453-1.705l1.5-2.598a1.25 1.25 0 0 1 1.706-.458l1.092.624a7.742 7.742 0 0 1 2.146-1.24V3.5M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 12a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
